export class PaginationModel<T> {
  results!: T[];

  total!: number;

  page!: number;

  limit!: number;
}
